export const enum URLParameters {
  Company = 'company',
  Flow = 'flow',
}
